import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { UserContext } from '../App';
import NomineeShell from './NomineeShell';
import { Button, Card, Stack, Text } from '../ui';

export default function ChooseContext() {
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const available = Array.isArray(currentUser?.availableContexts) ? currentUser.availableContexts : [];
  if (!currentUser) return <div>Loading...</div>;
  if (!available.includes('owner') || !available.includes('nominee')) {
    // Not a dual user — send them to the right place.
    navigate(currentUser?.type === 'nominee' ? '/nominee' : '/dashboard');
    return null;
  }

  const choose = async (next) => {
    setBusy(true);
    try {
      const resp = await api.post('/auth/switch-role', { active_context: next });
      const updated = {
        ...currentUser,
        type: resp?.data?.activeContext || next,
        activeOwnerSub: resp?.data?.activeOwnerSub ?? currentUser?.activeOwnerSub ?? null,
      };
      setCurrentUser(updated);
      try { localStorage.setItem('currentUser', JSON.stringify(updated)); } catch {}
      try { localStorage.setItem('dual_context_chosen_v1', '1'); } catch {}
      navigate(next === 'nominee' ? '/nominee' : '/dashboard');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed choosing context:', err?.response?.data || err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <NomineeShell force>
      <div style={{ minHeight: 'calc(100vh - 1px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 0' }}>
        <Card style={{ width: 420, maxWidth: '92vw' }}>
          <Stack gap={12}>
            <Text as="h2" size="lg" weight={800} style={{ margin: 0 }}>
              Choose how you want to use ProVault
            </Text>
            <Text muted style={{ margin: 0 }}>
              You have both an Owner account and nominee access. Please choose a view to continue.
            </Text>
            <Stack gap={12} style={{ marginTop: 6 }}>
              <Button type="button" disabled={busy} onClick={() => choose('owner')} style={{ width: '100%' }}>
                Continue as Owner
              </Button>
              <Button type="button" variant="secondary" disabled={busy} onClick={() => choose('nominee')} style={{ width: '100%' }}>
                Continue as Nominee
              </Button>
            </Stack>
          </Stack>
        </Card>
      </div>
    </NomineeShell>
  );
}


